const WORKOUTS_ACTION = {
  ADD_WORKOUT_SECTIONS: 'WORKOUTS_ADD_WORKOUT_SECTIONS',
  UPDATE: 'WORKOUTS_UPDATE',
  ADD_FOREIGN_KEYS: 'WORKOUTS_ADD_FOREIGN_KEYS',
  CLONE_RECOMMENDED: 'WORKOUTS_CLONE_RECOMMENDED',
  COPY_WORKOUT_SECTION: 'WORKOUTS_COPY_WORKOUT_SECTION',
  DELETE_PARENT_ID: 'WORKOUTS_DELETE_PARENT_ID',
  UPDATE_IMAGE: 'WORKOUTS_UPDATE_MEDIA',
  ADD_SMART: 'WORKOUTS_ADD_SMART',
  UPDATE_SMART_SUCCESS_STATUS: 'WORKOUTS_UPDATE_SMART_SUCCESS_STATUS',
  UPDATE_CURRENT: 'WORKOUTS_UPDATE_CURRENT',
  RESET_CURRENT: 'WORKOUTS_RESET_CURRENT',
  RESET_STARTED: 'WORKOUTS_RESET_STARTED',
  UPDATE_SMART: 'WORKOUTS_UPDATE_SMART',
  UPDATE_STARTED: 'WORKOUTS_UPDATE_STARTED',
  RESET_STARTED_STARTED: 'WORKOUTS_RESET_STARTED_STARTED',
  UPDATE_SUGGESTED: 'WORKOUTS_UPDATE_SUGGESTED',
  RESET_SUGGESTED: 'WORKOUTS_RESET_SUGGESTED',
  LOAD: 'WORKOUTS_LOAD',
  LOAD_RECOMMENDED: 'WORKOUTS_LOAD_RECOMMENDED',
  LOAD_BY_ID: 'WORKOUTS_LOAD_BY_ID',
  LOAD_BY_SHARE_KEY: 'WORKOUTS_LOAD_BY_SHARE_KEY',
  CLONE: 'WORKOUTS_CLONE',
  CREATE: 'WORKOUTS_CREATE',
  CREATE_SMART: 'WORKOUTS_CREATE_SMART',
  DELETE: 'WORKOUTS_DELETE',
  DELETE_SHARED_LOCALLY: 'WORKOUTS_DELETE_SHARED_LOCALLY',
  DELETE_WORKOUT_SECTION: 'WORKOUTS_DELETE_WORKOUT_SECTION',
  SAVE: 'WORKOUTS_SAVE',
  SHARE: 'WORKOUTS_SHARE',
  UPDATE_DATA: 'WORKOUTS_UPDATE_DATA',
  UPDATE_LOGGED_AT: 'WORKOUTS_UPDATE_LOGGED_AT',
  RESET_SMART: 'WORKOUTS_RESET_SMART',
  UPDATE_PLAN_ID: 'WORKOUTS_UPDATE_PLAN_ID',
  UPDATE_STARTED_AT: 'WORKOUTS_UPDATE_STARTED_AT',
  UPDATE_COMPLETION_TIME: 'WORKOUTS_UPDATE_COMPLETION_TIME',
  UPDATE_DIFFICULTY: 'WORKOUTS_UPDATE_DIFFICULTY',
  UPDATE_NAME: 'WORKOUTS_UPDATE_NAME',
  UPDATE_CALORIES: 'WORKOUTS_UPDATE_CALORIES',
  VALIDATE_CALORIES: 'WORKOUTS_VALIDATE_CALORIES',
  UPDATE_NOTE: 'WORKOUTS_UPDATE_NOTE',
  UPDATE_RECOMMENDED_AT: 'WORKOUTS_UPDATE_RECOMMENDED_AT',
  UPDATE_PROFILE_ID: 'WORKOUTS_UPDATE_PROFILE_ID',
  UPDATE_PLANNED_AT: 'WORKOUTS_UPDATE_PLANNED_AT',
  DELETE_PLANNED_AT: 'WORKOUTS_DELETE_PLANNED_AT',
  ENABLE_SHOULD_UPDATE_WORKOUT_AFTER_LOG_PREFERENCE: 'WORKOUTS_ENABLE_SHOULD_UPDATE_WORKOUT_AFTER_LOG_PREFERENCE',
  DISABLE_SHOULD_UPDATE_WORKOUT_AFTER_LOG_PREFERENCE: 'WORKOUTS_DISABLE_SHOULD_UPDATE_WORKOUT_AFTER_LOG_PREFERENCE',
  UPDATE_REMOTE_SHOULD_REPLACE_WORKOUT: 'WORKOUTS_UPDATE_REMOTE_SHOULD_REPLACE_WORKOUT',
  UPDATE_LOCAL_IS_DOWNLOADED: 'WORKOUTS_UPDATE_LOCAL_IS_DOWNLOADED',
  DELETE_LOCAL_IS_DOWNLOADED: 'WORKOUTS_DELETE_LOCAL_IS_DOWNLOADED',
  DELETE_RECOMMENDED_AT: 'WORKOUTS_DELETE_RECOMMENDED_AT',
  UPDATE_LOCAL_HAS_ASSOCIATION_CHANGE: 'WORKOUTS_UPDATE_LOCAL_HAS_ASSOCIATION_CHANGE',
  UPDATE_WEIGHT_UNIT: 'WORKOUTS_UPDATE_WEIGHT_UNIT',
  UPDATE_WORKOUT_SECTIONS_ORDER: 'WORKOUTS_UPDATE_WORKOUT_SECTIONS_ORDER',
  REORDERING_WORKOUT_SECTIONS: 'WORKOUTS_REORDERING_WORKOUT_SECTIONS',
  RESET_REORDERING_WORKOUT_SECTIONS: 'WORKOUTS_RESET_REORDERING_WORKOUT_SECTIONS',
  UPDATE_HAS_SUGGESTED_TO_COPY_FROM_WORKOUT_LOCAL: 'WORKOUTS_UPDATE_HAS_SUGGESTED_TO_COPY_FROM_WORKOUT_LOCAL',
  REORDERING_WORKOUT_EXERCISES: 'WORKOUTS_REORDERING_WORKOUT_EXERCISES',
  RESET_REORDERING_WORKOUT_EXERCISES: 'WORKOUTS_RESET_REORDERING_WORKOUT_EXERCISES',
  REORDERING_WORKOUT_EXERCISE_SETS: 'WORKOUTS_REORDERING_WORKOUT_EXERCISE_SETS',
  RESET_REORDERING_WORKOUT_EXERCISE_SETS: 'WORKOUTS_RESET_REORDERING_WORKOUT_EXERCISE_SETS'
}

export default WORKOUTS_ACTION
